import { render, staticRenderFns } from "./ItemsOption.vue?vue&type=template&id=af74acfe"
import script from "./ItemsOption.vue?vue&type=script&lang=js"
export * from "./ItemsOption.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports